import React from 'react';
import './About.css'

const About = () => {
    return (
        <div className="us">
            <div className="head">
                <h2 classname="text-white">About Us</h2>
            </div>
            <div className="about">
                <h5>
                Travels makes you happy.Have you always wanted to document your travel stories and let the world know about them? Photos and videos on IG and other social media sites are the best platforms to share your tales but can you really cash big time out of it? Maybe you can if you try your hand in vlogging! Travel vlogging has become one of the big trends that are followed by many travelers who visit new places, explore the nuances of the destinations, and offer tips and tricks to help fellow travelers. So, if you are someone who would like to indulge in this and join the bandwagon of travel vloggers, perhaps a few tips could help you in the process! We have listed out a set of travel vlog tips for beginners that would surely give you a good idea of how to approach travel vlogging.
                </h5>
            </div>
        </div>
    );
};

export default About;